import { render, staticRenderFns } from "./nodeDeclara.vue?vue&type=template&id=5552472b&scoped=true&"
import script from "./nodeDeclara.vue?vue&type=script&lang=js&"
export * from "./nodeDeclara.vue?vue&type=script&lang=js&"
import style0 from "./nodeDeclara.vue?vue&type=style&index=0&id=5552472b&scoped=true&lang=css&"
import style1 from "./nodeDeclara.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552472b",
  null
  
)

export default component.exports